export function insert(ob,id)
{
	
	return dispatch=>dispatch({type:"insert",payload:{...ob,id:id}})
}
export function del(id)
{
	return dispatch=>dispatch({type:"delete",payload:id})
}
export function edit(ob)
{
	return dispatch=>dispatch({type:"edit",payload:ob})
}

export function input(col,val)
{
	return dispatch=>dispatch({type:"input",payload:{col:col,val:val}})
}


export function update()
{
	return dispatch=>dispatch({type:"update"})
}

